"use client";
import type { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { getHolidays } from "../helpers";

// Utility function to check if a date is a weekend
const isWeekend = (day: Dayjs): boolean => {
  const dayOfWeek = day.day();
  return dayOfWeek === 0 || dayOfWeek === 6; // Sunday = 0, Saturday = 6
};

export function useWorkingDays(
  targetDate: Dayjs,
  daysCount: number,
  previousDays: boolean,
  countryCode?: string
): Dayjs[] {
  const [workingDays, setWorkingDays] = useState<Dayjs[]>([]);

  useEffect(() => {
    function getWorkingDays(
      referenceDate: Dayjs,
      count: number,
      country?: string
    ): Dayjs[] {
      let currentDate = referenceDate;
      const holidays = getHolidays(
        Number(referenceDate.format("YYYY")),
        country
      );
      const foundWorkingDays: Dayjs[] = [];

      while (foundWorkingDays.length < count) {
        if (previousDays) {
          currentDate = currentDate.subtract(1, "day");
        } else {
          currentDate = currentDate.add(1, "day");
        }
        const currentDateString = currentDate.format("YYYY-MM-DD");

        // Check if the current date is not a weekend and not a holiday
        if (!isWeekend(currentDate) && !holidays.includes(currentDateString)) {
          if (previousDays) {
            foundWorkingDays.unshift(currentDate);
          } else {
            foundWorkingDays.push(currentDate);
          }
        }
      }

      return foundWorkingDays;
    }

    const days = getWorkingDays(targetDate, daysCount, countryCode);
    setWorkingDays(days);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode, previousDays, daysCount]);

  return workingDays;
}
